// Modules
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';

import Call from 'services/data/call';
import Person from 'services/data/person';
import PersonLink from 'components/models/person/person-link';
import PhoneNumber from 'services/data/phone-number';
import SVG from 'components/widgets/icons/svg';
import Tooltip from 'components/widgets/overlays/tooltip';

import { Answer, CallDetails, Claim, Transfer } from './triage-options';
import TransferForm from './triage-options/forms/transfer';
import TriageItem from './triage-item';
import { alerts } from 'modules/alerts/actions';


export default class CallItem extends React.Component {
  static propTypes = {
    item: PropTypes.shape({
      open: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool
      ]),
      setOpen: PropTypes.func
    }),
    currentUser: PropTypes.object.isRequired,
    eagerUpdate: PropTypes.func.isRequired,
    onDashboard: PropTypes.bool
  };

  constructor() {
    super();

    this.update = this.update.bind(this);
    this.claim = this.claim.bind(this);
  }

  update(item) {
    this.props.eagerUpdate(item, 'call');

    return Call.update(item);
  }

  claim(item) {
    const user = this.props.currentUser;
    const update = _.defaults({ claimedBy: user, status: 'Active' }, item);

    this.props.eagerUpdate(update, 'call');

    return Call.claim(item.id)
      .catch(error => {
        if (!error.response || error.response.status !== 404) return;

        alerts.warning({ title: 'Call has already been claimed' });
      });
  }

  render() {
    const { item: call, currentUser, onDashboard, ...passed } = this.props;
    const { open } = call;
    const companyNickname = !_.isEmpty(call.company) && call.company && call.company.nickname;
    const person = !_.isEmpty(call.fromPerson) && call.fromPerson;
    const answerable = _.includes(['Incoming', 'Failed Transfer'], call.callStatus);
    const claimed = !_.isEmpty(call.claimedBy);
    const claimable = call.callStatus !== 'Incoming' && !claimed;
    const transferrable = call.callStatus === 'Active' && call.userOnCall.id === currentUser.id;
    const needsAction = answerable || claimable || transferrable;
    const transferringTo = !_.isEmpty(call.transferringTo) && Person.fullName(call.transferringTo);
    const lastUserOnCall = !_.isEmpty(call.lastUserOnCall) && Person.fullName(call.lastUserOnCall);
    const userOnCall = !_.isEmpty(call.userOnCall) && Person.fullName(call.userOnCall);
    const answerFailure = `Answer by ${transferringTo} failed`;
    const transferFailure = `Transfer from ${lastUserOnCall} to ${transferringTo} failed`;
    const initialAnswer = call.callStatus === 'Transferring' && !userOnCall;
    const callStatus = initialAnswer ? 'Answering' : call.callStatus;
    const matchedFrom = call.matchedFrom;

    const statusMap = {
      Answering: `Answering: ${transferringTo}`,
      Transferring: `Transferring to: ${transferringTo}`,
      Active: `Active: ${userOnCall}`,
      'Failed Transfer': lastUserOnCall ? transferFailure : answerFailure
    };

    const origin = (
      <Tooltip className="meta-tooltip" placement="bottom" title={PhoneNumber.format(call.from)}>
        <span className="truncate">
          { matchedFrom && person && !onDashboard && <PersonLink person={person} /> }
          { matchedFrom && person && onDashboard && Person.fullName(person) }
          { matchedFrom && !person && <span>{companyNickname}</span> }
          { !matchedFrom && <span>{PhoneNumber.format(call.from)}</span> }
        </span>
        { !onDashboard && <SVG src="svg/info.svg" /> }
      </Tooltip>
    );

    return (
      <TriageItem
        {...passed}
        itemOrigin={origin}
        payloadOrStatus={statusMap[callStatus] || call.callStatus}
        currentUser={currentUser}
        updateTriageItem={this.update}
        triageItem={call}
        onDashboard={onDashboard}
        className={classNames(_.kebabCase(call.callStatus))}
      >
        { !_.isEmpty(call.recording) && !open && <CallDetails call={call} /> }
        
        { needsAction && !open &&
          <div className="triage-primary-options">
            { answerable && <Answer call={call} /> }
            { claimable && <Claim triageItem={call} claim={this.claim} /> }
            { transferrable && <Transfer call={call} /> }
          </div>
        }

        { open === 'transfer' &&
          <TransferForm call={call} />
        }
      </TriageItem>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/models/triage/triage-items/call.js